/**
 * @author Umer Hassan, Brendan Magee
 * Refactored to peopleService by Umer Hassan
 * Airbnb style and preferences for Slack username and notification target by Brendan Magee
 */

function peopleService($http) {
  const service = {};
  const AUTHOR_SERVICE = '/authorservice-readonly';

  service.getUser = () => $http.get('api/user').then(response => response.data);

  service.saveNotificationTarget = target => (
    $http.patch('api/user/defaultNotificationTarget', target)
      .then(response => response.data));

  service.setSlackUsername = ({ username, integrationID }) => (
    $http.patch('api/user/slackUsername', { username, integrationID })
      .then(response => response.data));

  service.getUsersByName = async (name) => {
    const { data } = await $http.get(`api/users?name=${name}`);
    return data;
  };

  service.getAuthorByName = (name) => {
    const authorServiceQuery = `${AUTHOR_SERVICE}/api/?q={"byline":{"$regex":"${name}","$options":"i"}}&limit=20`;

    return $http.get(authorServiceQuery)
      .then((response) => {
        if (response.data && response.data.q_results) {
          return response.data.q_results.map((author) => {
            const webskedAuthor = Object.assign({}, { username: author._id, name: author.byline });
            return webskedAuthor;
          });
        }
        return [];
      });
  };

  service.getAuthorByEmail = (email) => {
    const authorServiceQuery = `${AUTHOR_SERVICE}/api/?q={"email":{"$regex":"${email}","$options":"i"}}`;
    return $http.get(authorServiceQuery)
      .then(response => response.data);
  };

  return service;
}

const serviceArray = [
  '$http',
  peopleService
];

module.exports = (ngModule) => {
  ngModule.factory('peopleService', serviceArray);
};
